export const LAYOUT_FIELDS = [
    {
        key: 'layout.screen.background',
        group: '화면 틀',
        label: '화면 기본 바탕',
        help: '바탕을 따로 정하지 않은 화면(공용 화면 틀 AppLayout을 쓰는 대부분의 화면)의 바탕. 기본 바탕은 흰색(다크 모드는 어두운 기본색), 보조 바탕은 연한 회색(다크 모드는 그보다 밝은 색)이다. 색 자체는 디자인 토큰(background.neutral.*)에서 바꾼다. 바탕을 직접 정한 화면은 그대로',
        type: 'enum',
        defaultValue: 'neutral-primary',
        options: [
            { value: 'neutral-primary', label: '기본 바탕 (background.neutral.primary)' },
            { value: 'neutral-secondary', label: '보조 바탕 (background.neutral.secondary)' },
        ],
    },
    {
        key: 'layout.divider.color',
        group: '구분선',
        label: '구분선 색',
        help: '목록·설정·주문 화면 등에서 영역을 나누는 가로 구분선(Divider)의 색',
        type: 'enum',
        defaultValue: 'brand-secondary',
        options: [
            { value: 'brand-secondary', label: '연한 회색 (background.brand.secondary)' },
            { value: 'neutral-tertiary', label: '조금 진한 회색 (background.neutral.tertiary)' },
            {
                value: 'neutral-inverse-tertiary',
                label: '진한 회색 (background.neutral-inverse.tertiary)',
            },
        ],
    },
    {
        key: 'layout.divider.thickness',
        group: '구분선',
        label: '구분선 두께',
        help: '두께를 따로 정하지 않은 구분선(가장 많이 쓰는 1px 구분선)의 두께(px로 입력, 0.5~4). 얇은 구분선(0.5px)으로 정해 둔 곳은 그대로',
        type: 'size',
        tokenGroup: 'dimension',
        defaultValue: 1,
        min: 0.5,
        max: 4,
    },
];
//# sourceMappingURL=layout.js.map